import { FormControl, MenuItem, Select } from '@mui/material';
import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import useMarkingClasses from '../MarkingClassesContext/MarkingClassesHook';

const Selector = () => {
  const { viewSelector, setViewSelector } = useMarkingClasses();
  const ulData = useSelector((state) => state?.class?.unitOfLearning || {});
  const [options, setOptions] = React.useState([]);
  const student = useSelector((state) => state?.classMarking?.student);

  useEffect(() => {
    if (ulData) {
      let newOptions = [];
      if (ulData.lcs.length > 0) {
        newOptions.push({
          label: 'Marking logs',
          value: 'logs'
        });
      }
      // if (ulData.workedExamples.length > 0) {
        newOptions.push({
          label: 'Worked examples',
          value: 'worked-examples'
        });
      // }
      // if (ulData.growthGoals.length > 0) {
        newOptions.push({
          label: 'Growth goals',
          value: 'growth-goals'
        });
      // }

      setOptions(newOptions);
    }
  }, [ulData]);
  if (!student) return <></>;

  return (
    <div
    className='bg-background absolute z-20 overflow-auto border-t border-muted flex items-center justify-center'
    style={{
      top: `calc(200px + 2rem)`,
      bottom: `calc(250px + 2rem)`,
      height: 50,
      width: 'calc(200px - 0.5rem)'
    }}
  >
    <FormControl variant='outlined' fullWidth className=' bg-background rounded'>
      <Select
        variant='outlined'
        value={viewSelector}
        onChange={(e) => setViewSelector(e.target.value)}
        size='small'
      >
        {options?.map((op) => (
          <MenuItem key={`selector-view-${op.value}`} value={op.value}>
            {op.label}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  </div>  
  );
};

export default Selector;
